import { AuthenticationStatusUseCase, GeneralError } from '51trips-frontend-core'
import { createBrowserRouter, Outlet, redirect } from 'react-router-dom'

import ErrorPage from './ErrorPage'
import { AuthenticationRepository } from './repositories/AuthenticationRepository'
import { AuthPage } from './routes/auth/AuthPage'
import { ForgottenPasswordPage } from './routes/auth/ForgottenPasswordPage'
import { userReadableDescription } from './utils/UserReadableDescription'
import {Root} from "./Root.tsx";
import {LoginPage} from "./routes/auth/LoginPage.tsx";
import {DashboardPage} from "./routes/DashboardPage.tsx";
import React from "react";
import {MobileTabletPage} from "./routes/MobileTabletPage.tsx";
import {TripGroupsPage} from "./routes/TripGroupsPage.tsx";
import {TripBookingPage} from "./routes/TripBookingPage.tsx";

// Resolves `false` on failure instead of rejecting: a rejected route loader
// bubbles to the root errorElement and blanks out the entire app (sidebar
// included) for what's usually a transient Firebase Auth hiccup. Treating it
// as "not authenticated" redirects to login instead, where the toast from
// userReadableDescription is still visible.
const resolveIsAuthenticcated = async () => {
  return new Promise<boolean>((resolve) => {
    const authenticationStatusUseCase = new AuthenticationStatusUseCase(
      new AuthenticationRepository()
    )

    authenticationStatusUseCase.isAuthenticated.subscribe({
      next: resolve,
      error: (error: GeneralError) => {
        userReadableDescription(error)
        resolve(false)
      }
    })
  })
}


export const router = createBrowserRouter([
  {
    path: '/',
    element: <Root />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: '',
        loader: () => {



          if (window.location.pathname === '/') {
            return redirect('/dashboard')
          }

          return null
        }
      },
      {
        path: 'mobile',
        element: <MobileTabletPage />
      },
      {
        path: 'auth',
        element: <AuthPage />,
        children: [
          {
            path: 'forgotten-password',
            element: <ForgottenPasswordPage />
          },
          {
            path: 'login',
            element: <LoginPage />
          }
        ]
      },
      {
        path: 'dashboard',
        element: <Outlet />,
        loader: async () => {
          const isAuthenticated = await resolveIsAuthenticcated()
          if (!isAuthenticated) {
            return redirect('/auth/login')
          }
          return null
        },
        children: [
          {
            path: '',
            element: <DashboardPage />
          },
          {
            path: '/dashboard/*',
            element: <DashboardPage />
          }
      ]
  }, {
      path: 'trips',
      element: <TripGroupsPage />,
  }, {
      path: 'register-trip',
      element: <TripBookingPage />,
  }
]}])
